import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";
import SpinnerMixin from "@/mixins/spinner";
import appointmentApi from "@/api/appointment/appointmentApiHttp";
import { dateValidationRule } from "@/helpers/formValidation";
import { downloadFile } from "@/helpers/fileHelper";
// As for the employees appointments, the period is the previous month
function getPreviousMonth() {
    const previousMonth = moment().subtract(1, "month");
    return {
        startDate: previousMonth
            .clone()
            .startOf("month")
            .toDate(),
        endDate: previousMonth
            .clone()
            .endOf("month")
            .startOf("day")
            .toDate()
    };
}
export default Vue.extend({
    mixins: [SpinnerMixin],
    data() {
        return {
            officesData: [],
            customersData: [],
            isDataLoaded: false,
            // No offices or customers means all of them
            officeIds: [],
            startDate: getPreviousMonth().startDate,
            endDate: getPreviousMonth().endDate,
            customerIds: [],
            validationOptions: {
                rules: {
                    customerAppointmentsExportStartDate: {
                        required: true,
                        date: [dateValidationRule]
                    },
                    customerAppointmentsExportEndDate: {
                        required: true,
                        date: [dateValidationRule],
                        endDateNotBeforeStartDate: [
                            (args) => {
                                const startDate = args.element.form.querySelector("#customerAppointmentsExportStartDate").ej2_instances[0].value;
                                const endDate = args.element.form.querySelector("#customerAppointmentsExportEndDate").ej2_instances[0].value;
                                return (startDate == null || endDate == null || endDate >= startDate);
                            },
                            this.$t("customers.appointmentsExport.endDateBeforeStartDateError")
                        ]
                    }
                }
            }
        };
    },
    computed: {
        ...mapGetters({
            hasMultipleOffices: "account/hasMultipleOffices"
        })
    },
    methods: {
        async exportCustomerAppointments() {
            const request = {
                startDate: moment(this.startDate).format("YYYY-MM-DD"),
                endDate: moment(this.endDate).format("YYYY-MM-DD"),
                officeIds: this.officeIds,
                customerIds: this.customerIds
            };
            // The dialog is closed right away and the page spinner shows the export in progress, so any
            // failure is notified with a toast instead of the form errors
            this.$parent.$parent.hide();
            try {
                const { file, fileName } = await appointmentApi.exportCustomerAppointments(request);
                downloadFile(file, fileName);
            }
            catch (errors) {
                this.$toast.showWarningToast(this.$t("shared.toastFailureTitle"), errors[0].message);
            }
        },
        cancel() {
            this.$parent.$parent.hide();
        },
        async onShow() {
            // Each opening starts again from all the offices and customers and the previous month
            const { startDate, endDate } = getPreviousMonth();
            this.startDate = startDate;
            this.endDate = endDate;
            this.officeIds = [];
            this.customerIds = [];
            await this.loadData();
        },
        async loadData() {
            if (this.isDataLoaded)
                return;
            try {
                const offices = await this.$store.dispatch("office/getAll");
                const customers = await this.$store.dispatch("customer/getAll", {
                    load: true
                });
                // The store lists are copied, as they are shared with the other pages
                this.officesData = offices.map((office) => ({
                    id: office.id,
                    name: office.name
                }));
                this.customersData = customers
                    .filter(customer => customer.deletedAt == undefined)
                    .map(customer => ({
                    id: customer.id,
                    fullName: `${customer.name} ${customer.surname}`
                }));
                this.isDataLoaded = true;
            }
            catch (errors) {
                this.$toast.showDangerToast(this.$t("shared.toastFailureTitle"), this.$t("shared.toastFailureContent", {
                    error: errors[0].message
                }));
            }
        }
    },
    mounted() {
        // The content is created with the customers page, so the data is loaded when the dialog is first opened
        this.$parent.$parent.$on("show", this.onShow);
    },
    beforeDestroy() {
        this.$parent.$parent.$off("show", this.onShow);
    }
});
